export default __webpack_public_path__ + "static/media/login-background.b8d1910c.png";